/** localStorage for device registration question (/devreg). */
export const DEVREG_STORAGE_KEY = 'npdsurvey:devreg';

export type DevRegAnswer = 'yes' | 'care_contact' | 'no_register';

export type DevRegAnswers = {
  registered: DevRegAnswer;
};

export function readDevRegAnswers(): DevRegAnswers | null {
  try {
    const raw = localStorage.getItem(DEVREG_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const r = (o as { registered?: unknown }).registered;
    if (r === 'yes' || r === 'care_contact' || r === 'no_register') {
      return { registered: r };
    }
    return null;
  } catch {
    return null;
  }
}

export function writeDevRegAnswers(data: DevRegAnswers): void {
  try {
    localStorage.setItem(DEVREG_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearDevRegAnswers(): void {
  try {
    localStorage.removeItem(DEVREG_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isDevRegComplete(): boolean {
  return readDevRegAnswers() != null;
}
